import Container from '../ui/Container';
import SectionHeading from '../ui/SectionHeading';
import Reveal from '../ui/Reveal';
import Icon from '../ui/Icon';
import { whyChooseUs } from '../../data/services';
import { quickFacts } from '../../data/stats';

export default function WhyChooseUs() {
  return (
    <section className="section bg-surface" id="why-us">
      <Container>
        <SectionHeading
          eyebrow="Why EcoVertex"
          title="Chosen for the paperwork, retained for the process"
          description="Anyone can carry material away. What matters is whether the documentation stands up in an inspection two years later."
        />

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {whyChooseUs.map((reason, index) => (
            <Reveal key={reason.title} delay={index * 0.06}>
              <div className="group relative h-full overflow-hidden rounded-xl2 border border-ink-100 bg-white p-7 shadow-soft transition-all duration-300 ease-smooth hover:-translate-y-1.5 hover:border-brand-200 hover:shadow-lift">
                {/* Hover wash */}
                <span
                  className="pointer-events-none absolute inset-x-0 top-0 h-1 origin-left scale-x-0 bg-gradient-to-r from-brand-500 to-brand-700 transition-transform duration-500 ease-smooth group-hover:scale-x-100"
                  aria-hidden="true"
                />
                <span className="grid h-12 w-12 place-items-center rounded-xl bg-brand-50 text-brand-700 transition-all duration-300 group-hover:scale-110 group-hover:bg-brand-600 group-hover:text-white">
                  <Icon name={reason.icon} className="h-6 w-6" />
                </span>
                <h3 className="mt-6 font-display text-lg font-semibold text-ink-900">{reason.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-500">{reason.description}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12 grid gap-px overflow-hidden rounded-xl2 border border-ink-100 bg-ink-100 sm:grid-cols-2 lg:grid-cols-4">
          {quickFacts.map((fact) => (
            <div key={fact.label} className="bg-white px-6 py-7 text-center">
              <p className="font-display text-3xl font-bold text-brand-700">{fact.value}</p>
              <p className="mt-2 text-xs font-medium uppercase tracking-wider text-ink-500">
                {fact.label}
              </p>
            </div>
          ))}
        </Reveal>
      </Container>
    </section>
  );
}
